import { Scale, FileWarning, Clock, Wrench } from "lucide-react";
import { PROBLEM_IMAGE } from "../assets";

const ITEMS = [
  {
    icon: Scale,
    title: "Ley LAU poco favorable",
    text: "La legislación residencial en España protege al inquilino. Ante un conflicto, recuperar tu vivienda puede llevar meses o incluso años.",
  },
  {
    icon: FileWarning,
    title: "Riesgo de impago",
    text: "Un solo inquilino que deje de pagar puede comprometer todo el rendimiento anual de tu vivienda.",
  },
  {
    icon: Clock,
    title: "Periodos de vacancia",
    text: "Cada mes vacío entre contratos es dinero perdido. Y la gestión recae siempre sobre ti.",
  },
  {
    icon: Wrench,
    title: "Reformas a tu cargo",
    text: "Cualquier desperfecto, mejora o reforma sale de tu bolsillo, sin garantía de recuperar la inversión.",
  },
];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="nr-section">
      <div className="nr-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="rounded-3xl overflow-hidden border border-[#EAEAEA]">
            <img
              src={PROBLEM_IMAGE}
              alt="Interior residencial moderno"
              className="w-full h-[420px] object-cover"
            />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="nr-eyebrow">Lo que debes saber</span>
          <h2 className="nr-h2 mt-4">
            El alquiler residencial tradicional ya no protege al propietario.
          </h2>
          <p className="mt-5 text-[16px] nr-text-soft max-w-[560px]">
            La legislación española deja al propietario en una posición
            vulnerable: contratos rígidos, impagos difíciles de resolver y toda
            la carga operativa sobre ti. Existen alternativas legales mucho más
            seguras para sacar el máximo a tu vivienda.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {ITEMS.map((it) => (
              <div
                key={it.title}
                data-testid={`problem-${it.title}`}
                className="flex gap-4"
              >
                <div className="flex-shrink-0 nr-service-icon !mb-0 !w-11 !h-11 !rounded-xl">
                  <it.icon size={20} />
                </div>
                <div>
                  <h3 className="nr-h3">{it.title}</h3>
                  <p className="mt-2 text-[14px] nr-text-soft leading-relaxed">
                    {it.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
